import type { AxiosError } from 'axios';
import type { SWRConfiguration } from 'swr';
import useSWR from 'swr';

import { DYDX_LCD_URL } from 'src/constants/transaction';
import type { ValidatorData } from 'src/types/validator';
import { get } from 'src/utils/axios';

export function useActiveValidatorsSWR(config?: SWRConfiguration) {
  const requestURL = `${DYDX_LCD_URL}/cosmos/staking/v1beta1/validators?status=BOND_STATUS_BONDED&pagination.limit=500&pagination.count_total=true`;

  const fetcher = (fetchUrl: string) => get<ValidatorData>(fetchUrl);

  const { data, error, mutate } = useSWR<ValidatorData, AxiosError>(requestURL, fetcher, {
    revalidateIfStale: false,
    revalidateOnReconnect: false,
    ...config,
  });

  return { data, error, mutate };
}
